module.exports = __webpack_public_path__ + "img/Heading.64b62b5d.svg";